// ********************************************************************************
// Classifier
// Handles stuff like view and submit articles weights, status etc. from Classifier
// ********************************************************************************

import * as Backend from '@/core/backend'

export async function loadRegistrations (params) {
  const res = await Backend.callApi({
    apiName: 'Classifier.LoadRegistrations',
    inputData: {
      Facility: params.facility,
      Status: params.status
    }
  })
  return res
}

export async function loadRegistration (id) {
  const res = await Backend.callApi({
    apiName: 'Classifier.LoadRegistration',
    inputData: {
      Id: id
    }
  })
  return res
}

export async function loadDeliveryInspectionRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'Classifier.LoadDeliveryInspectionRegistration',
    inputData: {
      Facility: params.Facility,
      RegistrationNo: params.RegistrationNo
    }
  })
  return res
}

export async function saveRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'Classifier.SaveRegistration',
    inputData: {
      Registration: params
    }
  })
  return res
}

export async function approveRegistration (params) {
  const res = await Backend.callApi({
    apiName: 'Classifier.ApproveRegistration',
    inputData: {
      Registration: params
    }
  })
  return res
}

export async function loadGroupedArticles (params) {
  const res = await Backend.callApi({
    apiName: 'Classifier.LoadGroupedArticles',
    inputData: {
      Facility: params
    }
  })
  return res
}
